<template>
    <div id="vupoint-wrapper">
        <div id="vupoint-portfolio">
            <PortfolioHeader 
                :pageName="pageName"
                :disciplines="disciplines" 
                :services="services"
                :pageLink="pageLink"
                :linkName="linkName"
            />
            <section class="bg-black text-white">
                <b-container class="py-100">
                    <p class="gotham-bold">
                        WEBSITE
                    </p>
                    <p class="gotham-book mb-0">
                        Our main goal for the VuPoint website was to create a clear and consistent user journey. As a condo community developed by Tribute Communities, we built it within Tribute’s larger corporate website to offer users a familiar yet fresh online experience. A stunning hero image dominates the initial landing page while floor plan collections and amenity maps support this comprehensive sales tool.
                    </p>
                </b-container>
            </section>
            <!-- <section>
                <FullWidthSliderWithColumns 
                :slides="sliderWithColumns"
                :styles="sliderWithColumnsStyles"/>
            </section> -->
            <section>
                <b-row>
                    <b-col sm="6" class="px-0">
                        <img src="/img/portfolio/vupoint/vupoint-logo-on-stipple-bg.jpg" alt="Vupoint" class="d-block w-100 h-100">
                    </b-col>
                    <b-col sm="6" class="px-0">
                        <img src="/img/portfolio/vupoint/vupoint-other-logos.jpg" alt="Vupoint" class="d-block w-100 object-fit-cover">
                    </b-col>
                </b-row>
            </section>
            <!--  -->
            <section>
                <b-row>
                    <b-col sm="6" class="px-0">
                        <img src="/img/portfolio/vupoint/vupoint-building-rendering.jpg" alt="Vupoint" class="d-block w-100 h-100">
                    </b-col>
                    <b-col sm="6" class="px-0">
                        <img src="/img/portfolio/vupoint/vupoint-interior-shots.jpg" alt="Vupoint" class="d-block w-100 object-fit-cover">
                    </b-col>
                </b-row>
            </section>
            <!--  -->
            <section>
                <ImageAndTextPortfolio 
                    :imageAndTextContent="imageAndTextContent"
                />
            </section>
            <!--  -->
            <section>
                <video 
                src="/videos/vupoint-video.mp4" 
                loop
                autoplay
                muted
                class="w-100 d-block">
                </video>
            </section>
            <!--  -->
            <ImageAndTextPortfolio 
                :imageAndTextContent="secondImageAndTextContent"
            />
            <!--  -->
            <section>
                <video 
                src="/videos/vupoint-social-video.mp4" 
                loop
                autoplay
                muted
                class="w-100 d-block">
                </video>
            </section>
            
            <section>
                <img src="/img/portfolio/vupoint/vupoint-building-rendering-side.jpg" alt="Vupoint Building - Side Building" class="d-block w-100">
            </section>

            <section class="conclusion">
                <b-container class="next-project stipple-bg py-5" fluid>
                    <NextProject :nextProject="nextProject"/>
                </b-container>
            </section>
            <Transition1063 />
            <AppFooter />
        </div>
        <!-- <div>
            <FullWidthSlider2 
            :slides="secondSliderItems"
            :styles="secondSliderStyles"/>
        </div> -->
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

export default {
    head: {
      title: "Guidelines Advertising Inc - 1063 Eglinton Ave",
      meta: [
        {
            hid: "description",
            content:
            "Guidelines Advertising is a full-service real estate marketing company with over 35 years experience in Toronto, Ontario, Canada."
        },
        { 
            hid: 'keywords', 
            name: 'keywords', 
            content: 'Toronto,Real estate décor consulting Toronto, real estate, marketing, toronto, branding, social media, web development, interior design, print, advertising, content marketing, eglinton'
        }
      ]
    },
    data() {
        return {
            scrollSmoother_vupoint: null,
            textAnimation_vupoint: null,
            fadeInUpElement_vupoint: null,
            disciplines: [
                {
                    name: "real estate development"
                }
            ],
            services: [
                {
                    name: "account management"
                },
                {
                    name: "brochure design"
                },
                {
                    name: "stationery design"
                },
                {
                    name: "video production"
                },
                {
                    name: "social media"
                },
                {
                    name: "rendering design"
                }
            ],
            pageName: "VuPoint Condos",
            pageLink: "",
            linkName: "",
            sliderWithColumns: [
                {
                    img: "/img/portfolio/cetana/cetana-logo-over-green-texture.jpg",
                    alt: "Cetana",
                    imgLeft: "/img/portfolio/cetana/cetana-grey-logo-green-bg.jpg",
                    imgRight: "/img/portfolio/cetana/cetana-white-logo-orange-bg.jpg",
                }
            ],
            sliderWithColumnsStyles: {
                bgColor: '#e7e4dc',
                textColor: '#000',
                sliderClass: 'slider-dots-black',
                imgOnLeftSide: true,
                heading: "CORPORATE INITIATIVES",
                desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                subheading: ''
            },
            fullWidthSliderImages: [
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-magazine-1.jpg",
                    alt: "DECO Magazie"
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-magazine-2.jpg",
                    alt: "DECO Magazie"
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-magazine-3.jpg",
                    alt: "DECO Magazie"
                }
            ],
            firstSliderStyles: {
                bgColor: '#586961',
                textColor: '#fff',
                sliderClass: false,
                imgOnLeftSide: false,
                heading: "SIGNAGE",
                desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                subheading: ''
            },
            firstSliderItems: [
                {
                    img: "/img/portfolio/cetana/cetana-here-for-the-future.jpg",
                    alt: "Cetana - Here For The Future"
                }
            ],
            secondSliderStyles: {
                bgColor: '#000',
                textBackgroundImg: 'stipple-bg',
                imgOnLeftSide: false,
                imgPadding: false,
                textColor: 'text-black',
                sliderClass: false,
                heading: "GUERILLA MARKETING CAMPAIGN",
                desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                subheading: ''
            },
            secondSliderItems: [
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-concierge.jpg",
                    heading: "CORPORATE INITIATIVES",
                    desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                    subheading: 'DECO CONCIERGE'
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-concierge.jpg",
                    heading: "CORPORATE INITIATIVES",
                    desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                    subheading: 'DECO CONCIERGE'
                }
            ],
            imageAndTextContent: {
                imgOnLeftSide: true,
                imgPadding: false,
                bgColor: '#111921',
                bgImageClass: "",
                textColor: "#fff",
                img: "/img/portfolio/vupoint/vupoint-brochure.jpg",
                alt: "Vupoint",
                heading: "BROCHURE",
                desc: "VuPoint is the largest Condo Community in the history of Pickering, and as such, the brochure had to clearly explain the value it brings to the city while sharing the many benefits it offers residents. This project was the first of three towers, allowing this brochure to be the first chapter of VuPoint’s story. With this in mind, we shared all of the must-knows, from pertinent renderings to amenity maps and suite floor plans. The brochure acted as a valuable sales tool – critical to VuPoint being the fastest-selling condo of 2022."
            },
            secondImageAndTextContent: {
                imgOnLeftSide: false,
                imgPadding: false,
                bgColor: '#00aea9',
                bgImageClass: "",
                textColor: "#fff",
                img: "/img/portfolio/vupoint/vupoint-social-media.jpg",
                alt: "Vupoint Social Media",
                heading: "SOCIAL MEDIA",
                desc: "We developed a comprehensive social media campaign to keep VuPoint relevant and generate excitement leading up to its initial release – no doubt a key contributor to its record sales numbers. This campaign continues to prove valuable, having a similar effect on the second tower now being sold and the third tower coming soon."
            },
            nextProject: {
                link: "/portfolio/millhouse",
                name: "Millhouse"
            }
        }
    },
    components: {
        PortfolioHeader: () => import('@/components/PortfolioHeader'),
        FullWidthSliderWithColumns: () => import('@/components/FullWidthSliderWithColumns'),
        FullWidthSlider: () => import('@/components/FullWidthSlider'),
        FullWidthSlider2: () => import('@/components/FullWidthSlider2'),
        ImageAndTextPortfolio: () => import('@/components/ImageAndTextPortfolio'),
        FullWidthImageSlider: () => import('@/components/FullWidthImageSlider'),
        Transition1063: () => import('@/components/Transition1063'),
        NextProject: () => import('@/components/NextProject'),
        AppFooter: () => import('@/components/AppFooter'),
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
        ScrollTrigger.refresh();
        setTimeout(() => {
            // CALL THIS FIRST SINCE ITS TECHNICALLY A SCROLLTRIGGER, SO ANY SCROLLTRIGGERS FOLLOWING THIS WOULD BE BUILT OFF OF THE SCROLLSMOOTHER
            this.initscrollSmoother_vupoint();
            // 
            this.initImgElReveal_vupoint();
            this.initTextReveal_vupoint();
        }, 500)
    },
    methods: {
        initscrollSmoother_vupoint() {
            this.scrollSmoother_vupoint = ScrollSmoother.create({
                wrapper: '#vupoint-wrapper',
                content: "#vupoint-portfolio",
                smooth: 3,
                effects: true
            });
            this.scrollSmoother_vupoint.effects(".plax-img", { speed: "auto" });
        },
        initImgElReveal_vupoint() {
            let fadeInUpEl = document.querySelectorAll(".fade-in-up-element");

            fadeInUpEl.forEach((container) => {
                let fadeInUpElement_vupoint = this.fadeInUpElement_vupoint;
                fadeInUpElement_vupoint = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.2
                    }
                });

                fadeInUpElement_vupoint.set(container, { autoAlpha: 1 });
                fadeInUpElement_vupoint.from(container, 1, {
                    opacity: 0,
                    y: 100,
                    ease: "power2.out"
                });
            });
        },
        initTextReveal_vupoint() {
            let revealText = document.querySelectorAll(".reveal-text");
            revealText.forEach((container) => {
                let textAnimation_vupoint = this.textAnimation_vupoint;
                textAnimation_vupoint = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.1
                    }
                });

                var splitHide = new SplitText(container, { type: "words", wordsClass: "hide-text" });
                var split = new SplitText(container, {
                    type: "words,lines",
                    wordsClass: "words",
                    linesClass: "lines"
                });
                textAnimation_vupoint.set(container, { autoAlpha: 1 });
                textAnimation_vupoint.from(split.words, {
                    delay: 0.5,
                    duration: 0.35,
                    yPercent: 100,
                    stagger: 0.03,
                    ease: 'power2.out'
                });
            })
        }
    },
    beforeDestroy() {
        setTimeout(() => {
            this.scrollSmoother_vupoint.kill();
        }, 500)
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables';

</style>